import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { COMPANY_EMAILS, COMPANY_PHONES } from '../../config/contacts';

interface PriceInquiryModalProps {
  open: boolean;
  onClose: () => void;
  productName?: string;
}

const PriceInquiryModal: React.FC<PriceInquiryModalProps> = ({ open, onClose, productName }) => {
  const [visible, setVisible] = useState(open);

  useEffect(() => {
    setVisible(open);
  }, [open]);

  if (!visible) {
    return null;
  }

  return createPortal(
    <div className="fixed inset-0 z-[90] flex items-center justify-center px-4">
      <div className="absolute inset-0 bg-slate-900/50" onClick={onClose} />
      <div className="relative bg-white rounded-2xl shadow-2xl max-w-md w-full p-6">
        <button
          type="button"
          onClick={onClose}
          className="absolute top-3 right-3 text-slate-400 hover:text-slate-700 text-2xl leading-none"
          aria-label="Закрыть"
        >
          ×
        </button>
        <h2 className="text-xl font-bold text-slate-900 mb-2">Уточнить цену у менеджера</h2>
        {productName && (
          <p className="text-sm text-slate-600 mb-4">Товар: {productName}</p>
        )}
        <p className="text-slate-700 mb-4">
          Позвоните нам или напишите на почту — менеджер подскажет актуальную цену и наличие.
        </p>
        <div className="space-y-3">
          <div>
            <h3 className="text-sm font-semibold text-slate-500 uppercase mb-1">Телефоны</h3>
            <div className="space-y-1">
              {COMPANY_PHONES.map((phone) => (
                <a key={phone.href} href={phone.href} className="block text-primary font-semibold hover:underline">
                  {phone.label}
                </a>
              ))}
            </div>
          </div>
          <div>
            <h3 className="text-sm font-semibold text-slate-500 uppercase mb-1">Email</h3>
            <div className="space-y-1">
              {COMPANY_EMAILS.map((email) => (
                <a key={email.href} href={email.href} className="block text-primary font-semibold hover:underline">
                  {email.label}
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default PriceInquiryModal;
